import { render, staticRenderFns } from "./BFootDatenschutz.vue?vue&type=template&id=4684a033&scoped=true&"
import script from "./BFootDatenschutz.vue?vue&type=script&lang=js&"
export * from "./BFootDatenschutz.vue?vue&type=script&lang=js&"
import style0 from "./BFootDatenschutz.vue?vue&type=style&index=0&id=4684a033&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4684a033",
  null
  
)

export default component.exports